import { StartMeasurementContainer } from '../containers/StartMeasurementContainer/index'

export const StartMeasurementPage = () => (
    <>
        <StartMeasurementContainer />
        
    </>
)